/* eslint-disable @typescript-eslint/naming-convention */
import type TypeTreeNode from './TypeTreeNode';
export default class TypeTree {
  public m_Nodes!: TypeTreeNode[];
  public m_StringBuffer!: byteArray;
}
